import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_V1 } from '../../../core/http/api.config';
import type {
  AuditAction,
  AuditEventPage,
  AuditEventRequest,
  AuditIngestResult,
} from '../models/audit.model';

export type AuditListParams = {
  page?: number;
  size?: number;
  domain?: string;
  action?: AuditAction;
  resourceType?: string;
  resourceId?: string;
  from?: string;
  to?: string;
};

@Injectable({ providedIn: 'root' })
export class AuditApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_V1}/audit/events`;

  listar(params: AuditListParams = {}): Observable<AuditEventPage> {
    let p = new HttpParams()
      .set('page', String(params.page ?? 0))
      .set('size', String(params.size ?? 20));
    if (params.domain) {
      p = p.set('domain', params.domain);
    }
    if (params.action) {
      p = p.set('action', params.action);
    }
    if (params.resourceType) {
      p = p.set('resourceType', params.resourceType);
    }
    if (params.resourceId) {
      p = p.set('resourceId', params.resourceId);
    }
    if (params.from) {
      p = p.set('from', params.from);
    }
    if (params.to) {
      p = p.set('to', params.to);
    }
    return this.http.get<AuditEventPage>(this.base, { params: p });
  }

  registrarLote(events: AuditEventRequest[]): Observable<AuditIngestResult> {
    return this.http.post<AuditIngestResult>(this.base, { events });
  }
}
